module.exports = __webpack_public_path__ + "img/mgolLogo.6068c72c.png";